<template>
  <el-popover
    :visible="visible"
    placement="top"
    :width="240"
    :show-arrow="true"
    @update:visible="visible = $event"
  >
    <template #reference>
      <span
        class="text-[10px] cursor-pointer select-none"
        :class="readCount > 0 ? 'text-primary-500 hover:text-primary-600' : 'text-slate-400'"
        @click.stop="visible = !visible"
      >
        {{ readCount > 0 ? `${readCount}人已读` : '未读' }}
      </span>
    </template>

    <!-- 弹窗内容 -->
    <div class="text-sm">
      <!-- Tab 切换 -->
      <div class="flex border-b border-slate-200 mb-2">
        <button
          class="flex-1 pb-2 text-xs font-medium text-center transition-colors cursor-pointer"
          :class="activeTab === 'read'
            ? 'text-primary-500 border-b-2 border-primary-500'
            : 'text-slate-400 hover:text-slate-600'"
          @click="activeTab = 'read'"
        >
          已读 ({{ readCount }})
        </button>
        <button
          class="flex-1 pb-2 text-xs font-medium text-center transition-colors cursor-pointer"
          :class="activeTab === 'unread'
            ? 'text-primary-500 border-b-2 border-primary-500'
            : 'text-slate-400 hover:text-slate-600'"
          @click="activeTab = 'unread'"
        >
          未读 ({{ unreadCount }})
        </button>
      </div>

      <!-- 成员列表 -->
      <div class="max-h-48 overflow-y-auto space-y-0.5">
        <template v-if="activeTab === 'read'">
          <div v-if="readMembers.length === 0" class="py-3 text-center text-xs text-slate-400">
            暂无人已读
          </div>
          <div
            v-for="member in readMembers"
            :key="member.userId"
            class="flex items-center gap-2 py-1 px-1 rounded hover:bg-slate-50"
          >
            <div class="w-6 h-6 rounded-full bg-primary-400 flex items-center justify-center text-[10px] text-white flex-shrink-0">
              {{ (member.name || member.userName || '').slice(-1) }}
            </div>
            <span class="text-xs text-slate-700 truncate flex-1">
              {{ member.name || member.userName }}
            </span>
            <span class="text-[10px] text-slate-400 flex-shrink-0">
              {{ formatReadTime(member.readTime) }}
            </span>
          </div>
        </template>
        <template v-else>
          <div v-if="unreadMembers.length === 0" class="py-3 text-center text-xs text-slate-400">
            全部已读
          </div>
          <div
            v-for="member in unreadMembers"
            :key="member.id"
            class="flex items-center gap-2 py-1 px-1 rounded hover:bg-slate-50"
          >
            <div class="w-6 h-6 rounded-full bg-slate-400 flex items-center justify-center text-[10px] text-white flex-shrink-0">
              {{ (member.name || '').slice(-1) }}
            </div>
            <span class="text-xs text-slate-700 truncate">{{ member.name }}</span>
          </div>
        </template>
      </div>
    </div>
  </el-popover>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  message: { type: Object, required: true },
  members: { type: Array, default: () => [] },
  currentUserId: { type: [String, Number], default: '' }
})

const visible = ref(false)
const activeTab = ref('read')

const readMembers = computed(() => {
  return (props.message.readBy || []).map(r => {
    const member = props.members.find(m => String(m.id) === String(r.userId))
    return {
      ...r,
      name: member?.name || r.userName || ''
    }
  })
})

const unreadMembers = computed(() => {
  const readUserIds = new Set((props.message.readBy || []).map(r => String(r.userId)))
  return props.members.filter(m =>
    String(m.id) !== String(props.currentUserId) && !readUserIds.has(String(m.id))
  )
})

const readCount = computed(() => readMembers.value.length)
const unreadCount = computed(() => unreadMembers.value.length)

function formatReadTime(timeStr) {
  if (!timeStr) return ''
  const date = new Date(timeStr)
  if (isNaN(date.getTime())) return ''
  const now = new Date()
  const time = date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false })
  if (date.toDateString() === now.toDateString()) return time
  return `${date.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' })} ${time}`
}
</script>
